import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Checkbox, Form, FormField, Icon, Input, Link, Modal, RadioGroup, SpaceBetween, TreeView } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import React from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';
const _preserve = React.version;

interface ItemRouting {
    idRouting: number;
    routing: string;
    label: string;
    value: string;
}
interface MenuItem {
    idMenu: number;
    isSideMenu: number;
    text: string;
    title: string;
    items?: MenuItem[];
    type?: string;
    icon?: string;
    description?: string;
    href?: string;
    section?: string;
    jsonRouting: number[];
}

export const SystemRoutingEditPage = () => {
    //const storeAdmin = useStoreAdmin();


    const { navigate } = useRouter();
    const { menu } = useGlobalState();
    const { } = useGlobalState();


    const [oMenu, setOMenu] = useState<MenuItem>();
    const [menus, setMenus] = useState<MenuItem[]>([]);
    const [routings, setRoutings] = useState<ItemRouting[]>([]);
    const [selectedRoutings, setSelectedRoutings] = useState<ItemRouting[]>([]);

    const handleSave = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/routing/all',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(oMenu)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.menus) {
                setOMenu(undefined)
                setMenus(data.menus)
                setRoutings(data.routings)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        handleGetAll()
    }, []);
    const handleGetAll = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/routing/all',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.menus) {
                setMenus(data.menus)
                setRoutings(data.routings)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        handleGetAll()
    }, []);


    // Función recursiva para transformar la estructura de menú a la estructura de TreeView
    const mapMenuToTreeItems = (menuItems: any[]) => {
        if (!menuItems || menuItems.length === 0) {
            return [];
        }

        return menuItems.map(item => {
            // La ID debe ser un string
            const id = item.idMenu.toString();

            // Determinar si hay ítems anidados (recursión)
            const nestedItems: any = item.items ? mapMenuToTreeItems(item.items) : [];

            // Determinar el icono basado en si es una sección o un enlace
            const iconName = getCloudscapeIconName(item);

            return {
                id: id,
                content: item.text,
                description: item.description,
                iconName: iconName, // Almacenamos el nombre del ícono en el ítem
                nestedItems: nestedItems.length > 0 ? nestedItems : undefined,
                href: item.href, // Mantenemos el href para la acción
                // Adjuntamos los datos originales por si son necesarios
                originalItem: item
            };
        });
    };

    const treeItems = useMemo(() => mapMenuToTreeItems(menus), [menus]);

    // Estado para manejar qué ítems están expandidos. Expandir 'Administración' (2) y 'Movimientos' (12) inicialmente
    const [expandedItems, setExpandedItems] = useState(['2', '12']);

    // Handler para expandir/colapsar un nodo
    const handleItemToggle = ({ detail }: any) => {
        setExpandedItems(prev =>
            detail.expanded
                ? [...prev, detail.item.id]
                : prev.filter(id => id !== detail.item.id)
        );
    };

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Editar menus</Header>
                    <TreeView
                        items={treeItems}
                        expandedItems={expandedItems}
                        // Definición de cómo se renderiza cada ítem
                        renderItem={item => ({

                            // Usa el 'iconName' que calculamos en el mapeo
                            icon: (
                                <Icon
                                    name={item.nestedItems ? "folder" : "file"}
                                    ariaLabel={item.content}
                                    // Los íconos de las secciones pueden ser de diferente variante para diferenciarlos
                                    variant={item.nestedItems ? "subtle" : "normal"}
                                />
                            ),
                            content: (
                                <Link onClick={() => {
                                    setOMenu(item.originalItem)
                                }}>{item.content}</Link>
                            ),
                            description: item.description,
                        })}
                        getItemId={item => item.id}
                        getItemChildren={item => item.nestedItems}
                        onItemToggle={handleItemToggle}
                        ariaLabel="Menú de Navegación del Sistema"
                        connectorLines="vertical"
                    />
                    <Modal size="large" visible={oMenu !== undefined} onDismiss={() => setOMenu(undefined)} header={`Enrutamiento de ${oMenu?.text} #${oMenu?.idMenu}`} closeAriaLabel="Cerrar modal de edición de menú">
                        <Form actions={<Button variant="primary" onClick={() => {
                            handleSave()
                        }}>Guardar cambios</Button>}>
                            <SpaceBetween direction="vertical" size="s">
                                <FormField label="Módulo">
                                    <Input type="text" value={oMenu?.text || ""} onChange={(detail) =>
                                        setOMenu({ ...oMenu!, text: detail.detail.value })
                                    } />
                                </FormField>
                                <FormField label="Título">
                                    <Input type="text" value={oMenu?.title || ""} onChange={(detail) =>
                                        setOMenu({ ...oMenu!, title: detail.detail.value })
                                    } />
                                </FormField>

                                <FormField label="Descripción">
                                    <Input type="text" value={oMenu?.description || ""} onChange={(detail) =>
                                        setOMenu({ ...oMenu!, description: detail.detail.value })
                                    } />
                                </FormField>

                                <FormField label="Ícono">
                                    <Input type="text" value={oMenu?.icon || ""} onChange={(detail) =>
                                        setOMenu({ ...oMenu!, icon: detail.detail.value })
                                    } />
                                </FormField>
                                <Checkbox checked={oMenu?.isSideMenu === 1} onChange={(detail) =>
                                    setOMenu({ ...oMenu!, isSideMenu: detail.detail.checked ? 1 : 0 })
                                }>Es menú laterial</Checkbox>
                                <RadioGroup direction='horizontal'
                                    value={oMenu?.type || ''} onChange={(detail) =>
                                        setOMenu({ ...oMenu!, type: detail.detail.value })
                                    }
                                    items={[
                                        {
                                            label: 'Enlace', value: 'link'
                                        },
                                        {
                                            label: 'Sección', value: 'section'
                                        }

                                    ]} />
                            </SpaceBetween>
                        </Form>
                    </Modal>
                </SpaceBetween>
            }
        />
    );
};
/*
{
    "text": "Banco",
    "idMenu": 56,
    "isFavorite": 0,
    "isSideMenu": 0,
    "title": "",
    "description": "Sistema de conciliación bancaria",
    "type": "link",
    "icon": "mdiDatabaseSyncOutline",
    "jsonRouting": [
        21
    ],
    "href": "#admin/movements/bank",
    "childrens": 0
}
    */
const getCloudscapeIconName = (item: any) => {
    // Si tiene items (es una sección), usamos 'folder' por defecto
    if (item.items && item.items.length > 0) {
        return 'folder';
    }

    // Si no es una sección, intentamos mapear por el nombre MDI si es posible, o por defecto 'file'
    const mdiIcon = item.icon?.toLowerCase();

    // Mapeo simple de nombres de íconos comunes de Material Design a CloudScape
    if (mdiIcon?.includes('account') || mdiIcon?.includes('group')) return 'user-profile';
    if (mdiIcon?.includes('briefcase') || mdiIcon?.includes('transfer')) return 'area-chart';
    if (mdiIcon?.includes('database') || mdiIcon?.includes('sync')) return 'settings';
    if (mdiIcon?.includes('calendar') || mdiIcon?.includes('multiselect')) return 'calendar';
    if (mdiIcon?.includes('airplane') || mdiIcon?.includes('flight')) return 'airplane';
    if (mdiIcon?.includes('invoice') || mdiIcon?.includes('ticket')) return 'credit-card';
    if (mdiIcon?.includes('undo') || mdiIcon?.includes('reverse')) return 'refresh';
    if (mdiIcon?.includes('percent')) return 'percent';
    if (mdiIcon?.includes('desktop')) return 'external-link';

    return 'file'; // Icono por defecto para enlaces/hojas
};
